"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformTimeToHHMMString = transformTimeToHHMMString;
function transformTimeToHHMMString(date) {
    const dateToString = new Date(date);
    let hours = dateToString.getUTCHours().toString();
    if (hours.length === 1) {
        hours = `0${hours}`;
    }
    let minutes = dateToString.getUTCMinutes().toString();
    if (minutes.length === 1) {
        minutes = `0${minutes}`;
    }
    return `${hours}:${minutes}`;
}
//# sourceMappingURL=transformTimeToHHMMString.js.map